module.exports = __webpack_public_path__ + "static/img/ag.ba87883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programs/ag.jpg
// module id = DI8n
// module chunks = 1